module.exports = "../images/cabin-hero.jpg?v=54113fb";